<template>
  <div class="root">
    <div class="user-icon-area">
      <div>
        <img src="@/assets/user.svg" />
        <p class="text"></p>
      </div>
    </div>
    <div v-if="!isLoggedInWithFirebaseAuth" class="login-button">
      <ButtonTextLink
        class="button"
        :isRed="true"
        @click-text="onClick"
        text="ログイン"
      />
    </div>
    <div v-else="isLoggedInWithFirebaseAuth" class="rank-area">
      <div class="rank-item">
        <p class="text">
          {{ registrationData.Point }}
        </p>
        <p class="unit">ポイント</p>
      </div>
      <div class="rank-item">
        <p class="text">{{ registrationData.Rank }}</p>
        <p class="unit">ランク</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import ButtonTextLink from "@/components/Atoms/ButtonTextLink";

export default {
  name: "show-my-page-data",
  components: {
    ButtonTextLink,
  },
  computed: {
    ...mapState(["registrationData", "isLoggedInWithFirebaseAuth"]),
    selectedMypageSpot() {
      return this.selectedSpotData.mypage;
    },
  },
  methods: {
    ...mapMutations(["setModal"]),
    onClick() {
      this.setModal("signin");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./../../unified.scss";

.root {
  margin-bottom: 1rem;
}
.text {
  text-align: center;
  margin: 4px 0;
}

.user-icon-area {
  background: #5cd5d6;
  padding-bottom: 40px;
  text-align: center;
  img {
    width: 100px;
    margin: 1rem auto 0.25rem;
  }
  .text {
    color: #fff;
  }
}

.rank-area {
  margin: -20px 1.25rem 0 1.25rem;
  display: flex;
  justify-content: space-between;
  border-radius: 20px;
  background: #fff;
  box-shadow: 2px 2px 5px 0px rgba(1, 39, 76, 0.2);
  padding: 1rem 0;
  .rank-item {
    width: 100%;
    text-align: center;
    p {
      margin: 0;
    }
    .text {
      color: #242529;
      font-weight: bold;
      margin-bottom: 0.25rem;
    }
    .unit {
      color: #848a94;
      font-size: 0.75rem;
    }
    &:not(:last-child) {
      border-right: 1px solid #e0e0e0;
    }
  }
}

.login-button {
  margin: -1.5rem 1.25rem 0;
  .button {
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/MyPage/MyData.vue